export default class DownloadUtil {
  static downloadCsv(data: string, filename: string): void {
    const pom = document.createElement("a");

    const blob = new Blob(["\ufeff" + data], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    pom.href = url;
    pom.setAttribute("download", filename);
    pom.click();
  }

  /**
   * \uc774\ubbf8 \uc644\uc131\ub41c Blob\uc744 \uadf8\ub300\ub85c \uc800\uc7a5\ud55c\ub2e4(@spec:2026-09-29-\ucc98\ubc29\uac80\ud1a0-\ud310\uc815\uae30\ub85d-\uc870\ud68c\ud654\uba74).
   * \uc11c\ubc84 CSV\ub294 \uc774\ubbf8 BOM\uc73c\ub85c \uc2dc\uc791\ud558\ubbc0\ub85c downloadCsv(\ubb38\uc790\uc5f4\uc5d0 BOM\uc744 \ub367\ubd99\uc784)\ub97c \uc7ac\uc0ac\uc6a9\ud558\uba74 BOM\uc774 \ub458\uc774 \ub41c\ub2e4.
   */
  static downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const pom = document.createElement("a");
    pom.href = url;
    pom.setAttribute("download", filename);
    document.body.appendChild(pom);
    pom.click();
    document.body.removeChild(pom);
    URL.revokeObjectURL(url);
  }
}
